/**
 * 
 * key
 * 
 */


const key = 'bXlXb3Jrc1FjQ29tcGxldGVkTGlzdA=='

export default key 